import React from 'react';
import './mobile-whatsapp-simulator.scss';
import { WhatsappChatSimulator } from '../whatspp-chat-simulator/whatsapp-chat-simulator';
import { useMobileWhatsappSimulator } from './hooks/use-mobile-whatsapp-simulator';
import {
  CustomInputTextArea,
  CustomSwipeableDrawer,
  WelcomeMenu,
  WhatsappChatMenu,
} from './components';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import { JTBD_PNGS, JTBD_SVGS } from '../../assets';
import { isEmpty } from 'lodash';
import { EmptyTestAgentView } from '../../../signup-jtbd';
import { GIFS, SVGS } from '../../../assets';
import {
  dispatch,
  updateShowAgentWorkingModal,
} from '@zonofi/seller-rtk-store';
import { finService, TrackEventType } from '@zonofi/seller-rtk-store';

interface MobileWhatsappSimulatorProps {
  changeToZonoMoneySimulator?: (url: string) => void;
  navigateToLaunchScreen?: () => void;
  navigateToRetrainScreen?: () => void;
  noFrame?: boolean;
  openConfirmationModal?: () => void;
  setContentIndex?: (val: number) => void;
  showErrorStrip?: boolean;
  viewSampleFile?: () => void;
}

export const MobileWhatsappSimulator: React.FC<
  MobileWhatsappSimulatorProps
> = ({
  changeToZonoMoneySimulator,
  navigateToLaunchScreen,
  navigateToRetrainScreen,
  noFrame = false,
  openConfirmationModal,
  setContentIndex,
  showErrorStrip = false,
  viewSampleFile,
}) => {
  const {
    chatContainerRef,
    containerRef,
    feedbackCount,
    firmName,
    groupedMessages,
    handleKeyDown,
    inputRef,
    menuItems,
    msgText,
    onCloseMenu,
    onCloseWelcomeMenu,
    onMenuClick,
    onMenuItemClick,
    onOpenWelcomeMenu,
    onSendMenuClick,
    onSendWelcomeMenuOption,
    openMenu,
    openWelcomeMenu,
    publishQuickReply,
    publishReaction,
    sendSampleQuestion,
    sendWhatsappMessage,
    setMsgText,
    showAgentWorkingModal,
    showGetOnWhatsappStrip,
    userActions,
    quickReply,
  } = useMobileWhatsappSimulator({ setContentIndex });

  return (
    <div
      className={`mobile-whatsapp-simulator tertiary-font-regular ${
        noFrame ? 'no-frame' : ''
      }`}
    >
      <div
        className={`mobile-whatsapp-simulator-header ${
          noFrame ? 'no-frame' : ''
        }`}
      >
        {!noFrame && (
          <div className="status-bar">
            <div className="status-bar-left">
              <span className="status-bar-left-time tertiary-font-semibold">
                9:41
              </span>
            </div>
            <div className="status-bar-right">
              <img
                // src={''}
                src={JTBD_PNGS.StatusBarIcons}
                alt=""
                className="status-bar-right-icons"
              />
            </div>
          </div>
        )}
        <div className="profile-bar">
          <div className="profile-bar-left">
            <img
              // src={''}
              src={JTBD_SVGS.BackBlackIcon}
              alt=""
              className="profile-bar-left-back"
              onClick={() => {
                openConfirmationModal?.();
              }}
            />
            <div className="profile-bar-left-data">
              <img
                // src={''}
                src={JTBD_PNGS.ProfileIcon}
                alt=""
                className="profile-bar-left-data-icon"
              />
              <div className="profile-bar-left-data-details">
                <span className="details-heading tertiary-font-medium">
                  {firmName}
                </span>
              </div>
            </div>
          </div>
          <div
            className="profile-bar-right"
            onClick={() => {
              navigateToRetrainScreen?.();
            }}
          >
            <img
              src={SVGS.EyeGreenIcon}
              alt=""
              className="profile-bar-right-icon"
            />
            <span className="profile-bar-right-text tertiary-font-semibold">
              Agent Content
            </span>
          </div>
        </div>

        {showErrorStrip ? (
          <div className="signup-onboarding-screen-body-top-strip">
            <div className="signup-onboarding-screen-body-top-strip-left">
              <img
                src={JTBD_SVGS.ErrorFillIcon}
                alt=""
                width={16}
                height={16}
              />
              <span className="signup-onboarding-screen-body-top-strip-left-text primary-font-regular">
                Agent is not trained!
              </span>
            </div>
            <div className="signup-onboarding-screen-body-top-strip-right">
              <span
                className="text-btn tertiary-font-semibold"
                onClick={() => {
                  navigateToRetrainScreen?.();
                }}
              >
                Train Agent
              </span>
            </div>
          </div>
        ) : (
          showGetOnWhatsappStrip && (
            <div className="signup-onboarding-screen-body-bottom-strip">
              <div className="signup-onboarding-screen-body-bottom-strip-left">
                <img
                  src={JTBD_SVGS.InfoFillWhiteIcon}
                  alt=""
                  width={16}
                  height={16}
                />
                <span className="signup-onboarding-screen-body-bottom-strip-left-text primary-font-regular">
                  Your AI Agent is ready to deploy!
                </span>
              </div>
              <div className="signup-onboarding-screen-body-bottom-strip-right">
                <ZoButton
                  onClick={() => {
                    finService.trackEvent(
                      TrackEventType.SIGNUP_DEPLOYMENT_STARTED
                    );
                    navigateToLaunchScreen?.();
                  }}
                  label={'Get it on Whatsapp'}
                  className="get-btn tertiary-font-medium"
                  size="small"
                />
              </div>
            </div>
          )
        )}
      </div>
      <div
        className="mobile-whatsapp-simulator-body"
        style={{
          background: `url(${JTBD_PNGS.MobileWhatsappBackground})`,
        }}
        ref={containerRef}
      >
        {showErrorStrip ||
          (showGetOnWhatsappStrip && (
            <div className="mobile-whatsapp-simulator-body-padding" />
          ))}
        {isEmpty(groupedMessages) ? (
          <EmptyTestAgentView setMsgText={sendSampleQuestion} />
        ) : (
          <WhatsappChatSimulator
            changeToZonoMoneySimulator={changeToZonoMoneySimulator}
            chatContainerRef={chatContainerRef}
            groupedMessages={groupedMessages}
            onMenuClick={onMenuClick}
            publishQuickReply={publishQuickReply}
            publishReaction={publishReaction}
            sendSampleQuestion={sendSampleQuestion}
          />
        )}
      </div>
      <div
        className={`mobile-whatsapp-simulator-footer ${
          noFrame ? 'no-frame' : ''
        }`}
      >
        {
          <div className="mobile-whatsapp-simulator-footer-strip">
            {/* <div className="mobile-whatsapp-simulator-footer-strip-left">
              <ZoButton
                onClick={navigateToLaunchScreen}
                label={'Get it on WhatsApp'}
                className="mobile-whatsapp-simulator-footer-strip-left-btn"
                endIcon={
                  <img
                    src={JTBD_SVGS.WhatsappWhiteIcon}
                    alt=""
                    width={16}
                    height={16}
                  />
                }
              />
              <div className="mobile-whatsapp-simulator-footer-strip-left-seperator" />
            </div> */}
            <div className="mobile-whatsapp-simulator-footer-strip-right">
              {userActions?.map((item) => (
                <ZoButton
                  onClick={item?.onClick}
                  label={item?.label}
                  className={`mobile-whatsapp-simulator-footer-strip-right-btn tertiary-font-medium ${
                    item?.isUsed ? 'used-btn' : ''
                  }`}
                />
              ))}
            </div>
          </div>
        }
        <div className="chat-bar">
          <img
            src={JTBD_SVGS.AddGreenIcon}
            alt=""
            className="chat-bar-add"
            onClick={onOpenWelcomeMenu}
          />
          <div className="chat-bar-input">
            <CustomInputTextArea
              value={msgText}
              onChange={(e) => {
                setMsgText(e.target.value);
              }}
              minRows={1}
              maxRows={4}
              adornmentPosition="bottom"
              inputTextAreaStyle={{
                fontSize: '16px',
                resize: 'none',
                overflow: 'hidden',
                outline: 'none',
                lineHeight: '24px',
                letterSpacing: '0.2px',
              }}
              inputFieldProps={{
                onKeyDown: handleKeyDown,
              }}
              placeholder="Ask me anything"
              ref={inputRef}
            />
          </div>
          <img
            // src={''}
            src={JTBD_SVGS.SendGreenIcon}
            alt=""
            className="chat-bar-send"
            height={38}
            onClick={() => sendWhatsappMessage()}
          />
        </div>
        {!noFrame && (
          <div className="footer-navigation">
            <div className="footer-navigation-bar" />
          </div>
        )}
      </div>
      {openMenu && (
        <CustomSwipeableDrawer
          open={openMenu}
          onClose={onCloseMenu}
          maxHeight="80%"
        >
          <WhatsappChatMenu
            items={menuItems}
            onMenuItemClick={onMenuItemClick}
            onSendClick={onSendMenuClick}
            quickReply={quickReply}
          />
        </CustomSwipeableDrawer>
      )}
      {openWelcomeMenu && (
        <CustomSwipeableDrawer
          open={openWelcomeMenu}
          onClose={onCloseWelcomeMenu}
          maxHeight="70%"
          showHandle={false}
        >
          <WelcomeMenu
            onClose={onCloseWelcomeMenu}
            onMenuItemClick={onMenuItemClick}
            onSendClick={onSendWelcomeMenuOption}
            quickReply={quickReply}
          />
        </CustomSwipeableDrawer>
      )}
      {showAgentWorkingModal && feedbackCount.good >= 3 && (
        <div className="mobile-whatsapp-simulator-overlay">
          <div className="mobile-whatsapp-simulator-drawer">
            <div className="mobile-whatsapp-simulator-content">
              <img
                src={GIFS.WorkingAwesome}
                alt=""
                className="mobile-whatsapp-simulator-image"
              />
              <div className="mobile-whatsapp-simulator-content-text">
                <span className="mobile-whatsapp-simulator-content-text-heading primary-font-bold">
                  Your Agent is Working Awesome!
                </span>
                <span className="mobile-whatsapp-simulator-content-text-description primary-font-regular">
                  Customers will love this. Want to take it live?
                </span>
              </div>
            </div>
            <div className="mobile-whatsapp-simulator-buttons">
              <ZoButton
                label={'Get it on WhatsApp'}
                onClick={() => {
                  finService.trackEvent(
                    TrackEventType.SIGNUP_DEPLOYMENT_STARTED
                  );
                  navigateToLaunchScreen?.();
                  dispatch(updateShowAgentWorkingModal(false));
                }}
                className="whatsapp-btn"
              />
              <ZoButton
                label={'I Want to Try More'}
                onClick={() => {
                  dispatch(updateShowAgentWorkingModal(false));
                  sendSampleQuestion('');
                }}
                className="more-btn"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
